'use strict';
	$('#hero-play-button').on("click", function () {
		var videoHeroSection = $(this).closest('.video-hero-banner');
		var videoHeroSectionHeight = $(videoHeroSection).height();
		var videoWrapper = videoHeroSection.find('.hero-video');
		var iframe = videoHeroSection.find('.hero-video iframe');
		var player = new Vimeo.Player(iframe);

		$(videoWrapper).height(videoHeroSectionHeight);

		var bgVideo = document.getElementById('bg-video');
		bgVideo.pause();
		videoHeroSection.addClass("video-playing");
		player.play();

		player.on('ended', function () {
			videoHeroSection.removeClass("video-playing");
			bgVideo.play();
		});

		$('#video-close-button').on("click", function () {
			player.pause();
			player.setCurrentTime(0);
			videoHeroSection.removeClass("video-playing");
			bgVideo.play();
		});
});

